import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      staleTime: 3 * 60 * 1000, // 3 minutes - data is fresh for 3 minutes
      gcTime: 3 * 60 * 1000, // 3 minutes - cache garbage collection time
      refetchOnMount: 'always', // Options: false | 'always' | true
    },
    mutations: {
      retry: 0,
    },
  },
});
